import Screen from '@/styles/Themes/Screen';
import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import { cssVars } from '@/styles/Themes/cssVars';
import { radius } from '@/styles/Themes/Metrics';

interface IIsWishlist {
    isWishlist: boolean;
}

export const PaypalCreditSection = styled.div<IIsWishlist>`
    background: ${({ isWishlist }) =>
        isWishlist ? `${cssVars.bg_ash_dark3}` : `${cssVars.bg_ash_normal}`};
    border-radius: ${radius.small};
    padding: 11px 8px;
    ${Text.Full.medium.regular};
    color: ${cssVars.fg_gray2_gray3};
    margin: 0 auto;

    ${Screen.ipad} {
        padding: 19px 20px 19px 25px;
        max-width: ${({ isWishlist }) => (isWishlist ? '400px' : '578px')};
        margin-top: 10px;
    }

    ${Screen.desktop} {
        max-width: ${({ isWishlist }) => (isWishlist ? '460px' : '578px')};
    }
`;
export const PaypalCreditContainer = styled.div<IIsWishlist>`
    margin: 0 auto;

    ${Screen.ipad} {
        max-width: ${({ isWishlist }) => (isWishlist ? '400px' : '380px')};
    }

    ${Screen.desktop} {
        max-width: ${({ isWishlist }) => (isWishlist ? '460px' : '440px')};
    }
`;

export const IconAndText = styled.div`
    display: flex;
    align-items: center;
    text-align: left;
`;

export const SeeMore = styled.a`
    text-decoration: underline;
    padding-left: 15px;
    cursor: pointer;
`;

export const PaypalCredit = styled.div`
    display: flex;
    align-items: center;
    background: ${cssVars.bg_paypal_background};
    border-radius: 10px;
    padding: 4px;
    margin-right: 10px;

    > svg {
        width: 81px;
        height: 32px;
    }

    ${Screen.ipad} {
        > svg {
            width: 87px;
            height: 34px;
        }
    }

    ${Screen.desktop} {
        width: 101px;
        height: 40px;
        margin-right: 20px;

        > svg {
            width: 101px;
            height: 40px;
            margin-right: 12px;
        }
    }
`;

export const PaypalText = styled.div`
    text-align: center;
    margin-top: 10px;

    ${Screen.desktop} {
        margin-top: 18px;
    }
`;
